export default __webpack_public_path__ + "static/media/logo-tst.e1afa8bc.png";